import React, { useEffect } from "react";

export default function ListJournal({ data, checkouts, close }) {
  useEffect(() => console.log(data), [data]);
  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        width: "110%",
        left: "-5%",
        background: "#fff",
        padding: "5px",
        borderRadius: "5px",
        zIndex: 2,
        paddingBottom: "15px",
        boxShadow: "7px 12px 19px -9px rgba(0,0,0,0.5)",
        border: "1px solid #eee",
      }}
    >
      <div style={{ textAlign: "right" }}>
        {" "}
        <button
          onClick={close}
          style={{
            padding: "10px",
            fontWeight: "bold",
            color: "#232",
            background: "#fff",
          }}
        >
          X
        </button>
      </div>
      {checkouts.map((ch) => (
        <div
          style={{
            background: data.find((el) => el.checkoutId == ch.id)
              ? "rgb(0, 169, 141,0.3)"
              : "rgb(244, 81, 108,0.2)",
            // color: j.verified ? "rgb(0, 169, 141,1)" : "rgb(244, 81, 108,01)",
            color: "#232",
            margin: "5px",
            padding: "7px",
            fontWeight: "bold",
            borderRadius: "5px",
          }}
        >
          {ch.name}
        </div>
      ))}
    </div>
  );
}
